/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempBadgesTagMultiple: {
  name: 'temp-badges-tag-multiple';
  data: string;
} = {
  name: 'temp-badges-tag-multiple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.293 3.293a1 1 0 0 1 .818-.287l9 1a1 1 0 0 1 .596.287l7 7a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1-.287-.596l-1-9a1 1 0 0 1 .287-.818Zm1.84 1.839.822 7.41L10 18.585 16.586 12l-6.045-6.044-7.409-.824ZM8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm9.707-3.207a1 1 0 1 0-1.414 1.414L21.586 12l-2.293 2.293a1 1 0 0 0 1.414 1.414L23 13.414a2 2 0 0 0 0-2.828l-5.293-5.293Z" fill="currentColor"/></svg>`,
};
